import { useDisclosure } from '@chakra-ui/react'
import { useState } from 'react'
import type {
  CopyMoveOperations,
  TagOperations,
  MediaLibraryModalsControllers,
} from '../../../interfaces'

export const useMediaLibraryModals = (): MediaLibraryModalsControllers => {
  const [openEmbedModal, handleEmbedModal] = useState(false)
  const [copyMoveOperation, setCopyMoveOperation] =
    useState<CopyMoveOperations>('copy')
  const [tagOperation, setTagOperation] = useState<TagOperations>('updateTags')

  return {
    embedModal: [openEmbedModal, handleEmbedModal],
    copyMoveState: [copyMoveOperation, setCopyMoveOperation],
    tagState: [tagOperation, setTagOperation],
    addToMediaCollection: useDisclosure(),
    renameFile: useDisclosure(),
    renameFolder: useDisclosure(),
    renameMediaCollection: useDisclosure(),
    publishFiles: useDisclosure(),
    tags: useDisclosure(),
    autoTags: useDisclosure(),
    removeAssetFromMultipleMediaCollections: useDisclosure(),
    removeMultipleAssetsFromMediaCollection: useDisclosure(),
    deleteMedia: useDisclosure(),
    deleteFileVersion: useDisclosure(),
    restoreFileVersion: useDisclosure(),
    copyMoveDrawer: useDisclosure(),
    photoEditor: useDisclosure(),
    imageEditor: useDisclosure(),
    removeBg: useDisclosure(),
    customFocusArea: useDisclosure(),
    shareAsset: useDisclosure(),
    shareMediaCollection: useDisclosure(),
    publicLinks: useDisclosure(),
    applyPathPolicy: useDisclosure(),
    download: useDisclosure(),
    applySavedExtension: useDisclosure(),
    bulkEditCustomMetadata: useDisclosure(),
  }
}
